/** OIDC configuration for Authentik. Auth is enabled only when VITE_OIDC_CLIENT_ID is set. */

export const OIDC_CLIENT_ID = import.meta.env.VITE_OIDC_CLIENT_ID ?? '';
export const AUTH_ENABLED = OIDC_CLIENT_ID !== '';

const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173';

export const OIDC_AUTHORIZE_URL = 'https://auth.helinks.com/application/o/authorize/';
export const OIDC_TOKEN_URL = 'https://auth.helinks.com/application/o/token/';
export const OIDC_USERINFO_URL = 'https://auth.helinks.com/application/o/userinfo/';
export const OIDC_END_SESSION_URL = 'https://auth.helinks.com/application/o/sts-wand-infra/end-session/';
export const OIDC_REDIRECT_URI = `${origin}/auth/callback`;
export const OIDC_SCOPES = 'openid profile email groups';
